import React, { Component } from 'react';
import AppUtils from '../../apputils';
import { CancelBooking, MyEvents, RateEvent } from '../../models/events';
import { PnkConnect } from '../../pnk-react/pnk-miniredux';
import BookedEventsPage from './booked-events';
import $ from 'jquery';
import { EventDetails } from '../EventDetails';
import CancelModal from './CancelModal';


class bookedEvents extends Component {
    constructor() {
        super()
        this.state = {
            myEvents: true,
            myEventsList: [],
            myEventsList2: [],
            event_id: '',
            EventDetails: false,
            isModalOpen: false,
            cancel_booking: false,
            join_id: '',

            // eventRating:'',
            rateEvent: false
        }
        this.filterBtnArray = ['All', 'Upcoming', 'Ongoing', 'Completed', 'Cancelled'];
        this.data = {

        }
        this.cancelObj = {}
    }

    HandleRouting = (route) => {
        AppUtils.HandlePageClick(this.props.componentprops, route)
    }

    componentDidMount = () => {
        $('#All').addClass('active');
    }

    GetEventDetails = (id) => {
      //    alert(id)
        this.setState({
            //  event_id: id,
            EventDetails: true,
        })

        this.ShowProfileModal(id);


    }

    ShowProfileModal = (id) => {
        this.props.componentprops.OpenModal(EventDetails, 'md', { modalClass: 'profile-entry-modal', headerClass: 'profile-entry-header', titleClass: 'profile-entry-title', title: 'Detail', action: 'Detail', id: id, close: this.CloseModal }, { action: 'Detail', name: 'Detail', close: this.CloseModal })
    }

    CloseModal = () => {

        this.props.componentprops.HandleCloseModal();
    }
    changeRating = (newRating, name) => {

        //  alert(newRating+'--'+name)
        var sep = name.indexOf(',');
        //var eventId = name.splice(',')
        var eventJoinId = name.substr(0, name.indexOf(','));
        var eventId = name.substr(sep + 1, name.length);
        //  alert(name.length)
        // alert(eventId)
        //  alert(name)  
        // alert(eventId)
        this.data = {
            user_id: localStorage.getItem('current_user_id'),
            event_id: eventId,
            event_join_id: eventJoinId,
            ratings: newRating
        }

        //alert('jjhb')

        this.setState({
            //  eventRating:newRating,
            rateEvent: true
        })



        //  console.log(this.data)


    }

    LeftTime = (leftTime) => {
        //alert(left);
        leftTime = leftTime.replace(/  /g, 'T');
        var curr_time = new Date();
        var startTime = new Date(leftTime);
        var diff = startTime.getTime() - curr_time.getTime()

      //  let diff_in_day = diff / (1000 * 60 * 60 * 24);
      //  let left_day_hours;
        // if (diff_in_day >= 1) {
        //     left_day_hours = Math.ceil(diff_in_day) + ' ' + 'Days'
        //     return left_day_hours;
        // }

        return diff;

    }

    FilterSession = (filter) => {

        this.filterBtnArray.forEach((item, i) => {
            if ($(`#${item}`).hasClass('active')) {
                $(`#${item}`).removeClass('active');
            }
        })

        $(`#${filter}`).addClass('active');




        let filterList = [];


        let EventList = this.state.myEventsList2;

        if (filter === 'Upcoming') {

            EventList.map((item, i) => {

                if (this.LeftTime(item.event_details[0].event_start_time) > 0 && item.event_details[0].event_status === 1 && item.status !==2) {
                    filterList.push(item);
                }
            })

            filterList.sort(((a, b) => b.event_details[0].event_start_time < a.event_details[0].event_start_time ? 1 : -1))

            this.setState({
                myEventsList: filterList
            })
        }

        else if (filter === 'Ongoing') {
            EventList.map((item, i) => {

                if (this.LeftTime(item.event_details[0].event_start_time) <= 0 && this.LeftTime(item.event_details[0].event_start_time) >= -item.event_details[0].event_duration * 60 * 1000 && item.event_details[0].event_status === 1) {
                    filterList.push(item);
                }
            })
            this.setState({
                myEventsList: filterList
            })
        }

        else if (filter === 'Cancelled') {
            EventList.map((item, i) => {

                if (item.event_details[0].event_status === 2 || item.status === 2) {
                    filterList.push(item);
                }
            })
            this.setState({
                myEventsList: filterList
            })
        }

        else if (filter === 'Completed') {



            EventList.map((item, i) => {

                if (this.LeftTime(item.event_details[0].event_start_time) <= -item.event_details[0].event_duration * 60 * 1000 && item.event_details[0].event_status === 1) {
                    filterList.push(item);
                }
            })
            this.setState({
                myEventsList: filterList
            })
        }

        else {
            this.setState({
                myEventsList: this.state.myEventsList2
            })
        }

    }

    HandleRateEventSuccessResponse = (res) => {


        this.setState({
            rateEvent: false,
            myEvents: true
        })
// let filter = ''
//         this.filterBtnArray.forEach((item, i) => {
//             if ($(`#${item}`).hasClass('active')) {
//                filter = $(`#${item}`).val
//             }
//         })
// alert(filter)
//         this.FilterSession(filter)

    }


    CancelBooking = (join_id, event_id) => {
       //   alert(join_id + '-' + event_id)
        this.setState({
            isModalOpen: true,
            join_id: join_id,
            event_id: event_id
        })

      

    }

    CloseCancelModal = () => {
        this.setState({
            isModalOpen: false
        })
    }

    CancelSession = () => {

        this.cancelObj = {
            join_id: this.state.join_id,
            event_id: this.state.event_id,
            user_id: localStorage.getItem('current_user_id')
        }

        this.setState({
            cancel_booking: true
        })


        console.log(this.cancelObj);

    }


    HandleCancelBookingSuccessResponse = (res)=>{
        if(res !== false){
            this.setState({
                cancel_booking:false,
                isModalOpen:false,
                event_id:'',
                join_id:''
            })
        }
        else{
            this.setState({
                cancel_booking:false,
                isModalOpen:false,
                event_id:'',
                join_id:''
            })
        }
        this.setState({
            myEvents:true
        })
    }


    HandleGetMyEventsSuccessResponse = (res) => {

        this.filterBtnArray.forEach((item, i) => {
            if ($(`#${item}`).hasClass('active')) {
                $(`#${item}`).removeClass('active');
            }
        })

        $('#All').addClass('active');


        if (res !== false) {
            console.log(JSON.stringify(res.data))
            let sortList = []

            sortList = res.data.eventjoininglist.rows
            //  console.log(JSON.stringify(sortList))
            // console.log('uuuu'  + JSON.stringify(sortList.event_details[0]))
            sortList.sort(((a, b) => b.event_details[0].event_start_time > a.event_details[0].event_start_time ? 1 : -1))
            //  console.log('sort'  + JSON.stringify(sortList))
            this.setState({
                myEventsList: sortList,
                myEventsList2: sortList,
                myEvents: false
            })

        //    console.log('uuuu' + JSON.stringify(this.state.myEventsList))

        }

        this.setState({
            myEvents: false
        })
    }

    render() {
        return (
            <div>
                <BookedEventsPage {...this.props}
                    HandleRouting={this.HandleRouting}
                    myEventsList={this.state.myEventsList}
                    changeRating={this.changeRating}
                    GetEventDetails={this.GetEventDetails}
                    FilterSession={this.FilterSession}
                    EventRating={this.EventRating}
                    filterBtnArray={this.filterBtnArray}
                    CancelBooking={this.CancelBooking}
                />
                <CancelModal {...this.props} isModalOpen={this.state.isModalOpen} CloseCancelModal={this.CloseCancelModal}
                    CancelSession={this.CancelSession}
                />
                {((this.state.myEvents === true) ? MyEvents(this.props.PnkStore, localStorage.getItem('current_user_id'), this.HandleGetMyEventsSuccessResponse) : "")}
                {((this.state.rateEvent === true) ? RateEvent(this.props.PnkStore, this.data, this.HandleRateEventSuccessResponse) : "")}
                {((this.state.cancel_booking === true) ? CancelBooking(this.props.PnkStore, this.cancelObj, this.HandleCancelBookingSuccessResponse) : "")}
            </div>
        )
    }
}

export const BookedEvents = PnkConnect(bookedEvents, '');